import type { ModuleDef } from './types.js';

/** System: the company's own configuration, and who may change it. */
export const SYSTEM_MODULES: readonly ModuleDef[] = [
  /* THE SETTINGS SPLIT. `settings.view` / `settings.edit` guarded every settings
     category alike, which put the security policy, the feature switches and the
     notification channels in the same box as the company's own name. Three
     modules now, one per kind of setting — see settingsScopes.ts for which
     category belongs to which. A stored `settings.view` / `settings.edit` is
     still honoured, as the two COMPANY-side boxes (catalog.ts, LEGACY_ALIASES). */
  {
    key: 'settings.company',
    label: 'Company identity settings',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: ['HR'], description: 'Read the company name, branding, regional formats, wording and report schedules' },
      { action: 'edit', defaultRoles: [], description: 'Change the company name, branding, regional formats, wording and report schedules' },
    ],
  },
  {
    key: 'settings.workforce',
    label: 'Workforce policy settings',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: ['HR'], description: 'Read attendance rules, workday, overtime, leave, letters and UAE compliance settings' },
      { action: 'edit', defaultRoles: ['HR'], description: 'Change attendance rules, workday, overtime, leave, letters and UAE compliance settings' },
    ],
  },
  {
    key: 'settings.app',
    label: 'Application settings',
    group: 'system',
    platform: true,
    permissions: [
      { action: 'view', defaultRoles: [], description: 'Read security policy, feature switches, face recognition, notifications and app lock' },
      { action: 'edit', defaultRoles: [], description: 'Change security policy, feature switches, face recognition, notifications and app lock' },
    ],
  },
  {
    key: 'settings.roles',
    label: 'Roles & access',
    group: 'system',
    // Not platform: the Administrator manages roles (owner, 2026-10-03).
    permissions: [
      { action: 'view', defaultRoles: [], description: 'See roles and who holds them' },
      { action: 'manage', defaultRoles: [], description: 'Create roles, change what they allow, assign people' },
    ],
  },
  {
    key: 'system.audit',
    platform: true,
    label: 'Audit log',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: [], description: 'Read the log of who changed what' },
    ],
  },
  {
    key: 'system.jobs',
    platform: true,
    label: 'Background jobs',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: [], description: 'See scheduled jobs and their last results' },
      { action: 'manage', defaultRoles: [], description: 'Run a background job on demand' },
    ],
  },
  {
    key: 'system.channels',
    platform: true,
    label: 'Notification channels',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: [], description: 'See which notification channels are configured' },
      { action: 'manage', defaultRoles: [], description: 'Send a test message through a channel' },
    ],
  },
  {
    key: 'system.fieldReleases',
    platform: true,
    label: 'Field app releases',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: [], description: 'See the field app versions that have been released' },
      { action: 'manage', defaultRoles: [], description: 'Upload and remove field app releases' },
    ],
  },
  {
    key: 'system.fieldPerf',
    platform: true,
    label: 'Field device performance',
    group: 'system',
    permissions: [
      { action: 'view', defaultRoles: [], description: 'See how field devices are performing' },
    ],
  },
];
